<template>
  <div>
    <div class="card" v-if="isCard">
      <header class="header-card">
        <p>{{ $t('catalogue.audience') }}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.nbHabitantsAireUrbaine | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.habitantAirUrbaine')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.audienceAn | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.audianceAn')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.audienceHebdo | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.audianceHebdo')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p
              class="has-text-link is-size-4 has-text-weight-bold">
            {{ entiteCommerciale.nbContactsAn | formatLocaleString }} &nbsp;</p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.nbContactAn')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.nbContactsHebdo | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.nbContactHebdo')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet" v-if="produitValue">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ produitValue.affimetrie.repetition | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.nbRepetition')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet" v-if="produitValue">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ produitValue.affimetrie.pourcentCouverture | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.pourcentCouverture')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet" v-if="produitValue">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ produitValue.affimetrie.grp | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.grp')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.localite | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.localite')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.surface | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.surface')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.revenuNetMenageAn | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.revenuNetMenageAn')}}
            </p>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <p class="has-text-link is-size-4 has-text-weight-bold">
              {{ entiteCommerciale.indiceCsp | formatLocaleString }} &nbsp;
            </p>
            <p class="has-text-default is-size-7">
              {{$t('centreCommercialEmplacement.indiceCsp')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline" v-else>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.nbHabitantsAireUrbaine | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
        {{$t('centreCommercialEmplacement.habitantAirUrbaine')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.audienceAn | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.audianceAn')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.audienceHebdo | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.audianceHebdo')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
        {{ entiteCommerciale.nbContactsAn | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.nbContactAn')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.nbContactsHebdo | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.nbContactHebdo')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet" v-if="produitValue">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ produitValue.affimetrie.repetition | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.nbRepetition')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet" v-if="produitValue">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ produitValue.affimetrie.pourcentCouverture | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.pourcentCouverture')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet" v-if="produitValue">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ produitValue.affimetrie.grp | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.grp')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.localite | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.localite')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.surface | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.surface')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.revenuNetMenageAn | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.revenuNetMenageAn')}}
        </p>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <p class="has-text-link is-size-4 has-text-weight-bold">
          {{ entiteCommerciale.indiceCsp | formatLocaleString }} &nbsp;
        </p>
        <p class="has-text-default is-size-7">
          {{$t('centreCommercialEmplacement.indiceCsp')}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c_audience',
  props: {
    entiteCommerciale: {
      type: Object,
      required: true,
    },
    isCard: {
      type: Boolean,
      required: false,
    },
    produitValue: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped>
</style>
